import React, { useState, useEffect, useCallback, useRef } from "react";
import axios from "axios";
import "./Logindetail.css";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import isURL from 'validator/lib/isURL';
import { SetDomainHeader } from "../../../Store/DomainData";
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button, Box, CircularProgress } from "@mui/material";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import Rightsidebar from "../Rightsidebar/Rightsidebar";
import FastForwardIcon from '@mui/icons-material/FastForward';
import FastRewindIcon from '@mui/icons-material/FastRewind';
import Stepperformhead from "./Stepperformhead";
import { SetUserToken } from "../../../Store/UserTokenSlice";
import { SetAuthToken } from "../../../Store/ApiAuthKey";
import logoimage from '../Asset/New_Assert/ESO_Logo.png';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import LogoutIcon from '@mui/icons-material/Logout';
import Select from "react-select";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import validator from 'validator'
import _ from 'lodash';
import { customDropdownStyles } from "../../../Commonalert/commonDropdown";
import InfoIcon from '@mui/icons-material/Info';
import Tooltip from "@mui/material/Tooltip";
import { CommonErrorAlert } from "../../../Commonalert/commonErrorAlert";
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';



function Domaindata() {
  const [formState, setFormState] = useState({
    webauthenticate: "",
    webtype: "",
    showResults: false,
    websiteName: "",
    webLink: "",
    onUsername: "",
    onPassword: "",
    errors: {
      webnameError: "",
      weblinkError: "",
      onUserError: "",
      onPasswordError: "",
      onPageError: "",
    },
  });

  const [showPasswordlgn, setShowPasswordlgn] = useState(false);
  const usernameRef = useRef(null)
  const passwordRef = useRef(null)
  const [loading, setLoading] = useState(false);
  const [apiOpen, setApiOpen] = useState(false);
  const [apiErrorMsg, setApiErrorMsg] = useState("");
  const [toggle, setToggle] = useState(false);
  const [faqData, setfaqData] = useState("2")
  const [initialfaqDateval, SetInitialfaqDateval] = useState([]);
  const [apiopen, setapiOpen] = React.useState(false);
  const [apierrorMsg, setapierrorMsg] = useState();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const ApiToken = useSelector((state) => state.apiauthkey.value);
  const [isDisabled, setDisabled] = useState(false);
  const [domainusr, setDomainusr] = useState("");
  const [domainpass, setdomainpass] = useState("");

  const [iconLoading, setIconLoading] = useState(false);

  const websiteoptions = [
    { value: "HTML", label: "HTML", name: "webtype" },
    { value: "JS", label: "JS", name: "webtype" },
    { value: "JS", label: "NOT SURE", name: "webtype" }
  ];


  const webauthenticatestatus = [
    { value: "Yes", label: "Yes", name: "webauthenticate" },
    { value: "No", label: "No", name: "webauthenticate" }
  ]

  const [verification_method, setVerification_method] = useState('txt');
  const verifyMethod = localStorage.getItem('verification_method');

  const handleClose = () => setApiOpen(false);

  const domainvalidUrl = async (weburl, username = "", password = "") => {
    const { websiteName, webLink, webauthenticate, onUsername, onPassword } = formState;
    setIconLoading(true)
    setDisabled(true)
    var datavar = `${process.env.REACT_APP_API_URL}domain/check_url/?url=${weburl}&http_username=${username}&http_password=${password}`

    const doaminsectiondatavalue = await axios.get(
      datavar,
      {
        headers: {
          Authorization: `${ApiToken}`,
        },
      }).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          errors.weblinkError = error?.response?.data?.error;
          setFormState((prevState) => ({ ...prevState, errors }));
          setDisabled(true)
          setIconLoading(false)
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }
      });
    if (doaminsectiondatavalue?.status == 200) {
      setDisabled(false)
      setIconLoading(false)
    }

  }
  const faqdatafun = async (menubutval = "") => {
    var datavar = `${process.env.REACT_APP_API_URL}domain/frequently_asked_questions/?menu=50`

    try {
      const doaminsectiondatavalue = await axios.get(
        datavar,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setApiOpen(true);
          setApiErrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }
      });
      if (doaminsectiondatavalue?.data) {
        SetInitialfaqDateval(doaminsectiondatavalue?.data?.faqs)
      }
    } catch (err) { }
  }
  useEffect(() => {
    faqdatafun()
  }, []);
  const handleToggle = () => {
    if (faqData != 1) {
      setfaqData(1)
    }
    else {
      setfaqData(2)
    }
    setToggle((pre) => !pre);
  };
  const debouncedSearch = useCallback(_.debounce((url, term1, term2) => {
    if (term1 != "")
      domainvalidUrl(url, term1, term2)

  }, 2500), []);
  const handleChange = (e) => {
    const { websiteName, webLink, webauthenticate, onUsername, onPassword } = formState;
    if (e.target) {
      const { name, value } = e.target;
      if (name == "onUsername")
        setDomainusr(e.target.value)
      if (name == "onPassword")
        setdomainpass(passwordRef.current.value)
      let errors = {};
      errors.weblinkError = "";
      errors.onUserError = "";
      errors.onPasswordError = "";
      if (name == "webLink") {
        if (value != "") {
          if (isURL(value)) {

            if (webauthenticate.value == "No" && value) {
              domainvalidUrl(value, onUsername, onPassword)
            }
            else if (webauthenticate.value == "Yes" && usernameRef.current.value && passwordRef.current.value && value) {
              domainvalidUrl(value, usernameRef.current.value, passwordRef.current.value)
            }
          }
          else {

            errors.weblinkError = "Enter Valid Website Link";
          }
        }
        else {
          errors.weblinkError = "Enter Valid Website Link";
        }
        setFormState((prevState) => ({ ...prevState, errors }));
      }
      if (webauthenticate.value == "Yes") {
        setDisabled(true)
        // if (!domainusr) {
        //   errors.onUserError = "Enter Username";
        // }
        // if (!onPassword) {
        //   errors.onPasswordError = "Enter Password";
        // }
        if (usernameRef.current.value && passwordRef.current.value && usernameRef.current.value.length > 3 && passwordRef.current.value.length > 3) {
          domainvalidUrl(webLink, usernameRef.current.value, passwordRef.current.value)
        }
        setFormState((prevState) => ({ ...prevState, errors }));
      }
      localStorage.setItem(e.target.name, e.target.value);
      setFormState((prevState) => ({
        ...prevState,
        [name]: value,
        ...(name === "webauthenticate" && {
          showResults: value === "Yes",
          onUsername: value === "No" ? "" : prevState.onUsername,
          onPassword: value === "No" ? "" : prevState.onPassword,
        }),
        errors: { ...prevState.errors, [`${name}Error`]: "" },
      }));

    } else {
      const { name, value } = e;
      if (name == "webauthenticate") {
        if (value == "No") {
          domainvalidUrl(webLink, onUsername, onPassword)
        }
      }
      localStorage.setItem(name, JSON.stringify(e));
      setFormState((prevState) => ({
        ...prevState,
        [name]: e,
        ...(name === "webauthenticate" && {
          showResults: value === "Yes",
          onUsername: value === "No" ? "" : prevState.onUsername,
          onPassword: value === "No" ? "" : prevState.onPassword,
        }),
        errors: { ...prevState.errors, [`${name}Error`]: "" },
      }));

    }



  };

  const validateForm = () => {
    const { websiteName, webLink, webauthenticate, onUsername, onPassword } = formState;
    let errors = {};
    let isValid = true;

    if (!websiteName) {
      errors.webnameError = "Enter Website Name";
      isValid = false;
    }

    if (!webLink) {
      errors.weblinkError = "Enter Link Address";
      isValid = false;
    } else if (!isURL(webLink)) {
      errors.weblinkError = "Enter Valid Link Address";
      isValid = false;
    }

    if (webauthenticate === "Yes") {
      if (!onUsername) {
        errors.onUserError = "Enter Username";
        isValid = false;
      }
      if (!onPassword) {
        errors.onPasswordError = "Enter Password";
        isValid = false;
      }
    }

    setFormState((prevState) => ({ ...prevState, errors }));
    return isValid;
  };

  const submitForm = async () => {
    setDisabled(true);
    if (!validateForm()) return;
    setLoading(true);

    const { websiteName, webLink, webtype, webauthenticate, onUsername, onPassword } = formState;
    const domainData = {
      domain_name: websiteName,
      domain_url: webLink,
      domain_type: webtype.value,
      domain_has_http: webauthenticate.value === "Yes",
      domain_http_username: onUsername,
      domain_http_password: onPassword,
      verification_method: verification_method
    };

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}domain/add_domain/`, domainData, {
        headers: { Authorization: ApiToken },
      });

      if (response?.data?.status_code == 200) {
        dispatch(SetDomainHeader({ header_selected: response.data.user_domain_id }));
        window.location.href = `${process.env.REACT_APP_DOMAIN}Domainownership`;
        setLoading(false);
      }
    } catch (error) {
      const status = error?.response?.status;
      if ([599, 500, 400, 404].includes(status)) {
        setApiErrorMsg(error?.response?.data?.error);
        setApiOpen(true);
        setDisabled(false);
      } else if (error?.code === "ERR_NETWORK") {
        navigate('/errorpages');
      } else {
        setDisabled(false);
        setFormState((prevState) => ({
          ...prevState,
          errors: { ...prevState.errors, onPageError: error.response.data.error },
        }));
        setDisabled(true)
      }
    } finally {
      setLoading(false);
    }
  };

  const TriggerLogout = async () => {
    try {
      const datavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}accounts/logout/`,
        {
          headers: {
            Authorization: `Token ${ApiToken}`,
          },
        }
      );

      if (datavalue.data) {

        localStorage.setItem("eso_auth_token", "");
        localStorage.setItem("eso_user_token", "");
        dispatch(SetUserToken({ eso_user_token: "" }));
        dispatch(SetAuthToken({ eso_auth_token: "" }));
        navigate("/login");
      }
    } catch (err) {
      localStorage.setItem("eso_auth_token", "");
      localStorage.setItem("eso_user_token", "");
      dispatch(SetUserToken({ eso_user_token: "" }));
      dispatch(SetAuthToken({ eso_auth_token: "" }))
      navigate("/login");
    }
  };


  const handleTogglePasswordlgn = () => {
    setShowPasswordlgn(!showPasswordlgn);
  };

  useEffect(() => {

    if (verifyMethod && verifyMethod !== 'undefined') {
      setVerification_method(verifyMethod);
    }

    if (localStorage.getItem("websiteName")) {
      setFormState(prevState => ({
        ...prevState,
        websiteName: localStorage.getItem("websiteName")
      }));
    }


    if (localStorage.getItem("webLink")) {
      setFormState(prevState => ({
        ...prevState,
        webLink: localStorage.getItem("webLink")
      }));
    }

    if (localStorage.getItem("webtype")) {
      setFormState(prevState => ({
        ...prevState,
        webtype: JSON.parse(localStorage.getItem("webtype"))
      }));
    }


    if (localStorage.getItem("webauthenticate")) {
      setFormState(prevState => ({
        ...prevState,
        webauthenticate: JSON.parse(localStorage.getItem("webauthenticate")),
        showResults: JSON.parse(localStorage.getItem("webauthenticate")).value === "Yes" ? true : false
      }));



    }

    if (localStorage.getItem("onUsername")) {
      setFormState(prevState => ({
        ...prevState,
        onUsername: localStorage.getItem("onUsername")
      }));
    }


    if (localStorage.getItem("onPassword")) {
      setFormState(prevState => ({
        ...prevState,
        onPassword: localStorage.getItem("onPassword")
      }));
    }


  }, [])


  const { websiteName, webLink, webtype, webauthenticate, showResults, errors } = formState;
  return (
    <>

      <div className="userdata">
        <div className="header_wrap" style={{ background: "#fff" }}>
          <div className="header_inner_top_wrap">
            <div className="drp_outer_wrap">
              <div class="Logo_wrap1">
                <img src={logoimage} alt="ESO Logo" class="Siteimage" style={{ width: "160px" }}></img>
              </div>
            </div>
          </div>
          <div className="header_inner_btm_wrap" style={{ gap: "5px" }}>
            <div className="bell-container top_icons_grp" >
              <span className="account_set_wrap">
                <button style={{ background: "#fff" }}
                  onClick={handleToggle}
                  title="Frequently Asked Question">
                  <QuestionMarkIcon />
                </button>
              </span>
            </div>
            {toggle && <Rightsidebar close={() => setToggle(false)} setToggle={setToggle} initialfaqDateval={initialfaqDateval} />}
            <div className="bell-container top_icons_grp" >
              <span className="account_set_wrap">
                <button style={{ background: "#fff" }}
                  onClick={TriggerLogout}
                  title="Logout">
                  <LogoutIcon />
                </button>
              </span>
            </div>
          </div>
        </div>

        {/* <div className="cnt_hdr_top_rgt_wrap" style={{ display: "flex", justifyContent: "space-between", width: "100%", padding: "10px", background: "#fff", position: "fixed", zIndex: 999 }}>
          <img
            className="Eso_logo"
            src={logoimage}
            alt="logo"
            style={{ width: "14%", background: "#fff" }}
          />

          <div style={{ display: "flex", alignItems: "center", gap: "10px", paddingRight: "20px" }}>
            <button
              onClick={handleToggle}
              className="faq_class"
              title="Frequently Asked Question"
              style={{ padding: "8px 13px 8px 7px" }}
            >
              <QuestionMarkIcon />
            </button>

            {toggle && <Rightsidebar close={() => setToggle(false)} setToggle={setToggle} initialfaqDateval={initialfaqDateval} />}

            <button onClick={TriggerLogout}>
              <span
                className="material-icons"
                title="Logout"
                style={{ marginLeft: '5px', padding: "10px 8px 10px 0px" }}
              >
                <LogoutIcon />
              </span>
            </button>
          </div>
        </div> */}

        <Stepperformhead setActiveStep={2} />

        <div className="outer-container1">
          <div className="userdata_inner">
            <h1>Please Share Your Website Details</h1>
            <p>    </p>
            <span className="domain-errordata">{errors.onPageError}</span>

            <form className="frm_container" style={{ justifySelf: "center" }}>
              <div className="campaigns-addedit-row" >
                <div className="keyword-col1-fields">
                  <div>
                    <label htmlFor="websiteName">Website Name:</label>
                    <input
                      id="websiteName"
                      title="This name is used as an alias to manage your domain."
                      type="text"
                      name="websiteName"
                      placeholder="Enter Website Name"
                      className="userdataselectdomain"
                      value={websiteName}
                      onChange={handleChange}
                      style={{ display: "block", marginTop: "5px", textAlign: "left", height: "45px" }}
                    />
                  </div>
                  <div>
                    <span className="domain-errordata">{errors.webnameError}</span>
                  </div>
                </div>
                <div className="keyword-col2-fields">
                  <div>
                    <label htmlFor="webLink">URL:</label>
                    <input
                      id="webLink"
                      type="text"
                      title="URL of your website (eg: www.example.com)"
                      name="webLink"
                      className="userdataselectdomain"
                      placeholder="Enter Website Url"
                      value={webLink}
                      onChange={handleChange}
                      style={{ display: "block", marginTop: "5px", width: "auto", height: "45px" }}
                    />
                  </div>
                  <div>
                    {" "}
                    <span className="domain-errordata">{errors.weblinkError}</span>
                  </div>
                </div>
              </div>
              <div className="campaigns-addedit-row" style={{ placeItems: "end" }}>
                <div className="keyword-col1-fields">
                  <div>
                    <div style={{ display: "flex" }}>
                      <label>Website Type:</label>
                      <Tooltip title="Select the technology used to render your website (HTML or JavaScript). If you are not sure, keep it as “JS”." arrow>
                        <InfoIcon style={{ width: "0.8em", cursor: "pointer" }} />
                      </Tooltip>

                    </div>
                    <Select
                      id="webtype"
                      name="webtype"
                      title="Select the technology used to render your website (HTML or JavaScript). If you are not sure, keep it as “JS”."
                      value={webtype}
                      options={websiteoptions}
                      placeholder="Enter Website Type"
                      onChange={handleChange}
                      styles={customDropdownStyles()}
                      menuPortalTarget={document.body}
                      classNamePrefix="addkeyword"
                    />
                  </div>
                </div>
                <div className="keyword-col2-fields">
                  <div>
                    <div style={{ margin: "15px 0 8px 0" }}>
                      <div style={{ display: "inline-flex", alignItems: "end" }}>
                        <label style={{ margin: 0, flex: 1, width: "12.2rem" }}>
                          Does your website need authentication to access?
                        </label>
                        <Tooltip title="If your website uses HTTP authentication" arrow>
                          <InfoIcon style={{ width: "0.8em", cursor: "pointer" }} />
                        </Tooltip>
                      </div>
                    </div>
                    <Select
                      id="webauthenticate"
                      name="webauthenticate"
                      title="Does your website need HTTP authentication?"
                      value={webauthenticate}
                      onChange={handleChange}
                      options={webauthenticatestatus}
                      placeholder="Enter Yes or No"
                      styles={customDropdownStyles()}
                      menuPortalTarget={document.body}
                      classNamePrefix="addkeyword"
                    />
                  </div>
                </div>
              </div>
              {showResults && (
                <>
                  <div className="campaigns-addedit-row">
                    <div className="keyword-col1-fields">
                      <div>
                        <label htmlFor="onUsername">Username:</label>
                        <input
                          type="text"
                          id="onUsername"
                          name="onUsername"
                          title="Username"
                          placeholder="Enter Username"
                          value={formState.onUsername}
                          onChange={handleChange}
                          ref={usernameRef}
                          style={{ display: "block", marginTop: "5px", height: "45px" }}
                        />
                      </div>
                      <div>
                        <span className="domain-errordata">{errors.onUserError}</span>
                      </div>
                    </div>
                    <div className="keyword-col2-fields">
                      {/* <label htmlFor="onPassword">Password:</label> */}
                      {/* <div>
                        <div className="password-container">
                          <input
                            type={showPasswordlgn ? "text" : "password"}
                            id="onPassword"
                            name="onPassword"
                            title="Password"
                            placeholder="Enter Password"
                            value={formState.onPassword}
                            onChange={handleChange}
                            ref={passwordRef}
                            style={{ display: "block", marginTop: "5px", paddingLeft: "19px", height: "43px" }}
                          />
                          <button
                            type="button"
                            className="togglepwd"
                            onClick={handleTogglePasswordlgn}
                          >
                            {showPasswordlgn ? <FaEye className="FaEy" /> : <FaEyeSlash className="FaEyeSlash" />}
                          </button>
                        </div>
                      </div> */}
                      <label for="onPassword" className="form-label">Password</label>
                      <input
                        type="password"
                        className="form-control domaindata-password"
                        id="onPassword"
                        placeholder="Enter Password"
                        name="onPassword"
                        autoComplete="off"
                        value={formState.onPassword}
                        onChange={handleChange}
                        ref={passwordRef}
                      />
                      <div className="frm_error">{errors.onPasswordError}</div>


                      {/* <div>
                        {" "}
                        <span className="domain-errordata">{errors.onPasswordError}</span>
                      </div> */}
                    </div>
                  </div>
                </>
              )}
              <table /*style={{ display: "grid", justifyContent: "center" }} */ >
                <tbody style={{ display: "grid" }}>

                </tbody>
              </table>
              <Box sx={{ mt: 3, display: "flex", justifyContent: "center" }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => navigate("/Impadddomain")}
                  sx={{
                    padding: "10px 10px",
                    borderRadius: "4px",
                    fontSize: "16px",
                    backgroundColor: "#ff601f",
                    color: "#fff",
                    "&:hover": { backgroundColor: "#ffdfd2", color: "#ff601f" },
                  }}
                >
                  <div style={{display: "contents"}}>
                    <span>Back</span><FastRewindIcon />
                  </div>
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={submitForm}
                  disabled={
                    !formState.websiteName ||
                    !formState.webLink ||
                    !formState.webtype ||
                    (!formState.webauthenticate && (!formState.onUsername || !formState.onPassword)) ||
                    (formState.webauthenticate.value == 'Yes' && (domainusr.length < 4 || domainpass.length < 4)) ||
                    isDisabled
                  }
                  sx={{
                    marginLeft: "30px",
                    padding: "10px 10px",
                    borderRadius: "4px",
                    fontSize: "16px",
                    backgroundColor:
                      !formState.websiteName || !formState.webLink || !formState.webtype ||
                        (!formState.webauthenticate && (!formState.onUsername || !formState.onPassword))
                        ? "#ccc"
                        : "#ff601f",
                    color:
                      !formState.websiteName || !formState.webLink || !formState.webtype ||
                        (!formState.webauthenticate && (!formState.onUsername || !formState.onPassword))
                        ? "#666"
                        : "white",
                    "&:hover": {
                      backgroundColor:
                        !formState.websiteName || !formState.webLink || !formState.webtype ||
                          (!formState.webauthenticate && (!formState.onUsername || !formState.onPassword))
                          ? "#ccc"
                          : "#ff7d45",
                    },
                  }}
                >
                  {iconLoading ?
                    <>Loading...</>
                    :
                    <>                
                    <div style={{display: "contents"}}>
                      <span>Next</span><FastForwardIcon />
                    </div></>
                  }
                </Button>
              </Box>
            </form>

          </div>
        </div>

        <Container maxWidth={false} className="footer-container">
          <Box className="footer-box">
            <Grid container className="footer-grid">
              <Grid item xs={12} md={12}>
                <div className="footer-left">
                  <p className="footer-text" style={{ textAlign: "center" }}>
                    All Rights Reserved Copyright © 2025 |
                    <a href="https://www.egrovesys.com/" target="blank">
                      <span className="footer-brand"> eGrove Systems</span>
                    </a>
                  </p>
                </div>
              </Grid>
            </Grid>
          </Box>
        </Container>
        <CommonErrorAlert
          data={{
            apiopen: apiOpen,
            apiErrorMsg: apiErrorMsg,
            isIconStyled: true
          }}
          closeAlert={handleClose} />
      </div >
    </>
  );
}

export default Domaindata;
